module.exports = "/assets/data/cc4ac4935fe565d89c57e432a19d51fd-MK6.data.json";